export enum LightDarkThemes {
    Light = 'light',
    Dark = 'dark'
}

export enum Themes {
    Alinea = 'alinea',
    K3000 = 'k3000',
    ExamMode = 'exam'
}

// export const accentK3000Color = '#00b3f3';
// export const accentK3000DarkColor = '#0094ca';

// export const NightTheme = {
//     primary: {
//         name: 'primary',
//         value: '#ffffff'
//     },
//     darkPrimary: {
//         name: 'dark-primary',
//         value: '#cecece'
//     },
//     secondary: {
//         name: 'secondary',
//         value: '#575756'
//     },
//     darkSecondary: {
//         name: 'dark-secondary',
//         value: '#313131'
//     },
//     aside: {
//         name: 'aside',
//         value: '#4a4a4e'
//     },
//     hover: {
//         name: 'hover',
//         value: '#848484'
//     },
//     accent: {
//         name: 'accent',
//         value: '#f39200'
//     },
//     darkAccent: {
//         name: 'dark-accent',
//         value: '#c57c0e'
//     }
// };

// export const DayTheme = {
//     primary: {
//         name: 'primary',
//         value: '#575756'
//     },
//     darkPrimary: {
//         name: 'dark-primary',
//         value: '#2e2e2d'
//     },
//     secondary: {
//         name: 'secondary',
//         value: '#ffffff'
//     },
//     darkSecondary: {
//         name: 'dark-secondary',
//         value: '#dddddd'
//     },
//     aside: {
//       name: 'aside',
//       value: '#f0efef'
//     },
//     hover: {
//         name: 'hover',
//         value: '#f0efef'
//     },
//     accent: {
//         name: 'accent',
//         value: '#f39200'
//     },
//     darkAccent: {
//         name: 'dark-accent',
//         value: '#c57c0e'
//     }
// };
